var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHelp)?_c('v-btn-toggle',{attrs:{"dense":"","group":""},model:{value:(_vm.chatOpen),callback:function ($$v) {_vm.chatOpen=$$v},expression:"chatOpen"}},[_c('v-btn',{attrs:{"icon":"","color":_vm.color,"x-large":"","value":true},on:{"click":_vm.openChat}},[_c('v-icon',[_vm._v("mdi-help-circle-outline")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }